// Common test payers from Stedi's network
export const stediPayerOptions = [
  { value: '60054', label: 'Aetna' },
  { value: '040', label: 'Anthem Blue Cross Blue Shield of CA' },
  { value: '62308', label: 'Cigna' },
  { value: '87726', label: 'UnitedHealthcare' },
];

export const claimFilingCodeOptions = [
  { value: '11', label: '11 - Medicare' },
  { value: '12', label: '12 - Medicaid' },
  { value: '13', label: '13 - Other Federal Program' },
  { value: '14', label: '14 - Veterans Administration Plan' },
  { value: '15', label: '15 - Other Non-Federal Programs' },
  { value: '16', label: '16 - Indemnity Insurance' },
  { value: '17', label: '17 - Commercial HMO' },
  { value: 'AM', label: 'AM - Automobile Medical' },
  { value: 'BL', label: 'BL - Blue Cross/Blue Shield' },
  { value: 'CH', label: 'CH - Champus' },
  { value: 'CI', label: 'CI - Commercial Insurance Co.' },
  { value: 'DS', label: 'DS - Disability' },
  { value: 'HM', label: 'HM - Health Maintenance Organization' },
  { value: 'LM', label: 'LM - Liability Medical' },
  { value: 'MA', label: 'MA - Medicare Part A' },
  { value: 'MB', label: 'MB - Medicare Part B' },
  { value: 'MC', label: 'MC - Medicaid' },
  { value: 'OF', label: 'OF - Other Federal Program' },
  { value: 'TV', label: 'TV - Title V' },
  { value: 'VA', label: 'VA - Veterans Affairs Plan' },
  { value: 'WC', label: 'WC - Workers Compensation Health Claim' },
  { value: 'ZZ', label: 'ZZ - Mutually Defined' },
];

export const placeOfServiceOptions = [
  { value: '11', label: '11 - Office' },
  { value: '21', label: '21 - Inpatient Hospital' },
  { value: '22', label: '22 - On Campus-Outpatient Hospital' },
  { value: '23', label: '23 - Emergency Room - Hospital' },
  { value: '31', label: '31 - Skilled Nursing Facility' },
  { value: '32', label: '32 - Nursing Facility' },
  { value: '33', label: '33 - Custodial Care Facility' },
  { value: '34', label: '34 - Hospice' },
  { value: '41', label: '41 - Ambulance - Land' },
  { value: '42', label: '42 - Ambulance - Air or Water' },
  { value: '51', label: '51 - Inpatient Psychiatric Facility' },
  { value: '52', label: '52 - Psychiatric Facility-Partial Hospitalization' },
  { value: '53', label: '53 - Community Mental Health Center' },
  {
    value: '54',
    label:
      '54 - Intermediate Care Facility/Individuals with Intellectual Disabilities',
  },
  { value: '55', label: '55 - Residential Substance Abuse Treatment Facility' },
  { value: '56', label: '56 - Psychiatric Residential Treatment Center' },
  {
    value: '61',
    label: '61 - Comprehensive Inpatient Rehabilitation Facility',
  },
  {
    value: '62',
    label: '62 - Comprehensive Outpatient Rehabilitation Facility',
  },
  { value: '65', label: '65 - End-Stage Renal Disease Treatment Facility' },
  { value: '71', label: '71 - Public Health Clinic' },
  { value: '72', label: '72 - Rural Health Clinic' },
  { value: '81', label: '81 - Independent Laboratory' },
];

export const claimFrequencyOptions = [
  { value: '1', label: '1 - Original' },
  { value: '2', label: '2 - Corrected' },
  { value: '3', label: '3 - Replacement' },
  { value: '4', label: '4 - Termination for Inpatient Only' },
  { value: '7', label: '7 - Replacement of Prior Claim' },
  { value: '8', label: '8 - Void/Cancel of Prior Claim' },
  { value: '9', label: '9 - Final Bill for HH PPS Episode' },
];

export const paymentResponsibilityOptions = [
  { value: 'A', label: 'A - Payor Responsibility Four' },
  { value: 'B', label: 'B - Payor Responsibility Five' },
  { value: 'C', label: 'C - Payor Responsibility Six' },
  { value: 'D', label: 'D - Payor Responsibility Seven' },
  { value: 'E', label: 'E - Payor Responsibility Eight' },
  { value: 'F', label: 'F - Payor Responsibility Nine' },
  { value: 'G', label: 'G - Payor Responsibility Ten' },
  { value: 'H', label: 'H - Payor Responsibility Eleven' },
  { value: 'P', label: 'P - Primary' },
  { value: 'S', label: 'S - Secondary' },
  { value: 'T', label: 'T - Tertiary' },
  { value: 'U', label: 'U - Unknown' },
];
